import { object, Schema, string } from 'yup';

type ReactSelectValidatorParams = {
  /** Custom validator for option value */
  valueValidator?: Schema;
  /** Custom validator for option label */
  labelValidator?: Schema;
};

export const reactSelectValidator = (params?: ReactSelectValidatorParams) =>
  object({
    label: params?.labelValidator ? params?.labelValidator : string(),
    value: params?.valueValidator ? params?.valueValidator : string(),
  });
